import { useApiWithAuth } from '@/hooks/api';
import { updatePerson } from '@/store/people/actions/people';
import type { Person } from '@/store/people/types';
import { type ReactNode, useState, useCallback } from 'react';
import type { PersonFieldKey } from '../people/people/fields';
import { PersonModal } from '../people/people/modal';
import { ProfileModalContext, type Callback, type ProfileModalState } from '.';
import { TagsModalContext } from '.';
import TagsModal from './tags';

export function ProfileModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [currentPerson, setCurrentPerson] = useState<Person | null>(null);
  const [saving, setSaving] = useState(false);
  const [onUpdated, setOnUpdated] = useState<Callback | null>(null);
  const [fields, setFields] = useState<PersonFieldKey[] | undefined>(undefined);
  const { api, auth } = useApiWithAuth();
  const state: ProfileModalState = {
    open,
    setOpen,
    currentPerson,
    setCurrentPerson,
    setOnUpdated,
    setFields,
  };

  const onSave = useCallback(
    async (item: Person) => {
      setSaving(true);
      await updatePerson(
        { onUpdated: onUpdated?.callback },
        { api, auth, item },
      );
      setSaving(false);
    },
    [api, auth, onUpdated],
  );

  return (
    <ProfileModalContext.Provider value={state}>
      <>
        <PersonModal
          isOpen={open}
          onOpenChange={setOpen}
          target={currentPerson}
          onSave={onSave}
          saving={saving}
          fields={fields}
        />
        {children}
      </>
    </ProfileModalContext.Provider>
  );
}

export function TagsModalProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [currentPerson, setCurrentPerson] = useState<Person | null>(null);
  const [onUpdated, setOnUpdated] = useState<Callback | null>(null);
  const state = {
    open,
    setOpen,
    currentPerson,
    setCurrentPerson,
    setOnUpdated,
  };

  return (
    <TagsModalContext.Provider value={state}>
      <>
        <TagsModal
          open={open}
          setOpen={setOpen}
          currentPerson={currentPerson}
          onUpdated={onUpdated?.callback || (() => {})}
        />
        {children}
      </>
    </TagsModalContext.Provider>
  );
}
